/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_f0_102_48(e) {
  let t = (0, ReactCompiler.c)(7),
    { valor: n } = e;
  if (!n) return null;
  let r = n.normalize(`NFD`).replace(/\p{M}/gu, ``).toUpperCase(),
    i = `whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${r === `CRITICA` || r === `ALTA` ? `border-(--error) text-(--error)` : r === `MEDIA` ? `border-(--warning) text-(--warning)` : `border-(--border) text-(--text)`}`,
    a;
  t[0] === n
    ? (a = t[1])
    : ((a = n.charAt(0).toUpperCase()), (t[0] = n), (t[1] = a));
  let o;
  t[2] === n
    ? (o = t[3])
    : ((o = n.slice(1).toLowerCase()), (t[2] = n), (t[3] = o));
  let s = a + o,
    c;
  return (
    t[4] !== i || t[5] !== s
      ? ((c = <span className={i} children={s} />),
        (t[4] = i),
        (t[5] = s),
        (t[6] = c))
      : (c = t[6]),
    c
  );
}
